import React, { useCallback, useMemo, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import TransformPanel from "../../../components/transform/TransformPanel";
import { useTransform } from "../../../hooks/useTransform";
import TextTransformList from "../../text-transform/TextTransformList";
import GlassPanel from "../GlassPanel";

const PasteTab: React.FC<{ isApproved: boolean }> = () => {
  const [sourceText, setSourceText] = useState("");
  const [refresh, setRefresh] = useState(false);
  const transform = useTransform();
  const handleRefreshComplete = useCallback(() => setRefresh(false), []);

  const hasText = useMemo(() => !!sourceText.trim(), [sourceText]);
  const wordCount = sourceText.trim() ? sourceText.trim().split(/\s+/).length : 0;
  const charCount = sourceText.length;

  return (
    <>
      <Typography
        sx={{
          fontFamily: "'Syne', sans-serif",
          fontSize: "0.8rem",
          fontWeight: 700,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          color: "var(--teal)",
          mb: 1,
        }}
      >
        Paste &amp; Process Text
      </Typography>

      <GlassPanel>
        <TextField
          fullWidth
          multiline
          minRows={8}
          maxRows={16}
          placeholder="Paste or type your text here…"
          value={sourceText}
          onChange={(e) => {
            const nextText = e.target.value;
            setSourceText(nextText);
            transform.setSourceText(nextText);
          }}
        />

        {hasText && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              mt: 1,
              alignItems: "center",
              fontSize: "0.72rem",
              color: "var(--t3)",
            }}
          >
            <span>📊 {wordCount.toLocaleString()} words</span>
            <span>✏️ {charCount.toLocaleString()} chars</span>
          </Box>
        )}

        <TransformPanel
          displayText={transform.displayText}
          hasText={hasText}
          isTransforming={transform.isTransforming}
          isStreamingResult={transform.isStreamingResult}
          transformError={transform.transformError}
          downloadUrl={transform.transformDownloadKey || undefined}
          onTransform={transform.runTransform}
          onReset={transform.reset}
        />
      </GlassPanel>

      <Box sx={{ mt: 3 }}>
        <Typography
          sx={{
            fontFamily: "'Syne', sans-serif",
            fontSize: "0.8rem",
            fontWeight: 700,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "var(--teal)",
            mb: 1,
          }}
        >
          Recent Transforms
        </Typography>
        <GlassPanel>
          <TextTransformList
            refresh={refresh}
            onRefreshComplete={handleRefreshComplete}
          />
        </GlassPanel>
      </Box>
    </>
  );
};

export default PasteTab;
